import ConsoleHandler from './Console';
import { HandlerType } from './constants';
import SentryHandler from './Sentry';
import { Handler } from './types';

export const handlerFactory = (type: string | undefined): Handler => {
  switch (type) {
    case HandlerType.console:
      return new ConsoleHandler();
    case HandlerType.sentry:
      return new SentryHandler();
    default:
      // oxlint-disable-next-line no-console
      console.warn(`Unknown logger handler. ${type} is not valid type. Default to console.`);
      return new ConsoleHandler();
  }
};
